import { Container, Text } from '@chakra-ui/react'
import { ErrorFallback, withSentryErrorReporting } from '@components/Fallback'
import {
  CheckPermissionsWrapper,
  Operations,
  Permission,
} from '@lib/permissions'
import { RESOURCE_ID } from '@lib/permissions/Resource'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const readLiveOutputsPermission = new Permission(
  RESOURCE_ID.liveOutput,
  Operations.Read
)

const FailOver = ({ error }) => (
  <ErrorFallback title={'Error Loading Live Outputs'} error={error}>
    <>
      <Text mt={2}>There was an error loading your live outputs.</Text>
      <Text>
        Try reloading the page or choosing another item from the side menu
      </Text>
    </>
  </ErrorFallback>
)

const LiveOutputRoute = () => (
  <Container maxW={'75rem'}>
    <CheckPermissionsWrapper permissions={[readLiveOutputsPermission]}>
      <Outlet />
    </CheckPermissionsWrapper>
  </Container>
)

export const Route = createFileRoute('/_auth/o/$orgId/liveOutputs')({
  component: LiveOutputRoute,
  beforeLoad: () => ({ getTitle: () => 'Live Outputs' }),
  errorComponent: withSentryErrorReporting(FailOver),
  loader: () => ({
    crumb: 'Live Outputs',
  }),
})
